import * as B from '@blueprintjs/core';
import React from 'react';

import {FIRST_ROWS} from './utils';

/**
 * Grows a billing table a page at a time, and collapses it back to its first rows.
 */
const ShowMoreRows: React.FC<{
  shownRowCount: number;
  nextShownRowCount: number;
  loadedRowCount: number;
  // More rows exist on the server beyond the loaded ones, so how many is unknown.
  hasUnloadedRows?: boolean;
  loading?: boolean;
  onShowMore: () => void;
  onShowLess: () => void;
}> = ({
  shownRowCount,
  nextShownRowCount,
  loadedRowCount,
  hasUnloadedRows = false,
  loading,
  onShowMore,
  onShowLess,
}) => {
  const moreLoadedRowCount = Math.min(nextShownRowCount, loadedRowCount) - shownRowCount;
  const canShowMore = moreLoadedRowCount > 0 || hasUnloadedRows;
  const canShowLess = shownRowCount > FIRST_ROWS && loadedRowCount > FIRST_ROWS;

  if (!canShowMore && !canShowLess) {
    return null;
  }

  return (
    <div>
      {canShowMore && (
        <B.Button
          small
          minimal
          intent={B.Intent.PRIMARY}
          loading={loading}
          text={moreLoadedRowCount > 0 ? `Show ${moreLoadedRowCount} more` : 'Show more'}
          onClick={onShowMore}
        />
      )}
      {canShowLess && (
        <B.Button small minimal intent={B.Intent.PRIMARY} text="Show less" onClick={onShowLess} />
      )}
    </div>
  );
};

export default ShowMoreRows;
